import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Box, Grid, Icon, Link } from 'bonfire-kindling';
import axios from 'helpers/axios';
import { PROJECT_COUNTS } from 'constants/apis';
import { Container } from 'components';
import Logo from 'assets/BF-VendorsLogo.png';
import LoginForm from './components/LoginForm';
import ProjectKpi from './components/ProjectKpi';

// 15 mins.
const PROJECT_COUNTS_STALE_TIME = 15 * 60 * 1000;

export default () => {
  const { t } = useTranslation();
  const { data: { data: counts } = {} } = useQuery(
    ['projectCounts'],
    () => axios.get(PROJECT_COUNTS),
    { staleTime: PROJECT_COUNTS_STALE_TIME }
  );

  return (
    <Grid container height="100%" width="100%">
      <Grid item xs={12} md={5}>
        <Container justifyContent="center">
          <Box
            sx={{
              width: { xs: '70%', sm: '80%' },
              marginBottom: { xs: 0, md: '6rem' },
            }}
          >
            <img src={Logo} alt="Bonfire" width="180px" />
            <Typography component="h1" variant="h1" sx={{ fontSize: { sm: '3rem' }, mt: 3, mb: 2 }}>
              {t('login.main_login.welcome_back')}
            </Typography>
            <Typography variant="body1">{t('login.main_login.welcome_message')}</Typography>
            {counts && (
              <Box display="flex" mt={3}>
                <ProjectKpi
                  icon={<Icon iconName="globe-americas" style={{ fontSize: '1.25rem' }} mr={1} />}
                  value={counts.totalOpen.toLocaleString()}
                  label={t('login.main_login.total_opportunities')}
                />
                <ProjectKpi
                  icon={<Icon iconName="star" style={{ fontSize: '1.25rem' }} mr={1} />}
                  value={counts.recentlyOpened.toLocaleString()}
                  label={t('login.main_login.new_opportunities')}
                />
              </Box>
            )}
          </Box>
        </Container>
      </Grid>
      <Grid item xs={12} md={7}>
        <Box bgcolor="blue.light" height="100%">
          <Container justifyContent="center">
            <Box bgcolor="white" p={5} minWidth="320px" width="60%">
              <Typography variant="h4" component="h2" sx={{ textAlign: 'center' }}>
                {t('login.main_login.login_to_premium_vendor')}
              </Typography>
              <LoginForm />
              <Box mt={6} display="flex" flexDirection="column" alignItems="center">
                <Typography variant="body2">
                  <strong>{t('login.main_login.dont_have_an_acconut')}</strong>
                </Typography>
                <Link
                  component={RouterLink}
                  to="/subscribe"
                  variant="body2"
                  target="_self"
                  rel={undefined}
                >
                  <strong>{t('login.main_login.sign_up')}</strong>
                </Link>
              </Box>
            </Box>
          </Container>
        </Box>
      </Grid>
    </Grid>
  );
};
